require("@rails/ujs").start();
require("jquery");
window.jQuery_custom = $.noConflict(true);
require("src/cocoon");
require("src/loadjs");
import 'bootstrap/js/dist/modal';
import bootbox from 'bootbox';

window.bootbox = bootbox;

// TODO
window.$ = $;
window.jQuery = $;

require('jquery-ui/ui/widgets/datepicker');
require('jquery-ui/ui/widgets/autocomplete');
require('jquery-ui/ui/i18n/datepicker-de');

jQuery_custom(document).ready(function() {
  jQuery_custom("input[type='date']").each(function() {
    if(this.type != 'date'){
      jQuery_custom(this).datepicker({ dateFormat: 'dd.mm.yy', language: 'de' });
    }
  });
});

window.addEventListener('cf_init', function (window) {
  if (CookieFirst.consent === null || !CookieFirst.consent.functional) {
    jQuery_custom(document).ready(function() {
      jQuery('[data-component="venue-map"]').find('.privacyText').toggleClass('d-none');
      jQuery('[data-component="infection-map"]').find('.privacyText').toggleClass('d-none');
    });
  }
}, false)
